import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import ScrollToTop from 'react-router-scroll-top';

import NowPlayingProvider from './contexts/now-playing.context';
import AuthProvider from './contexts/auth.context';
import FavoritesProvider from './contexts/favorites.context';

import App from './App';

ReactDOM.render(
  <AuthProvider>
    <FavoritesProvider>
      <NowPlayingProvider>
        <BrowserRouter>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </BrowserRouter>
      </NowPlayingProvider>
    </FavoritesProvider>
  </AuthProvider>,
  document.getElementById('root')
);
